export const CustomerDetailsOverViewData = {
  overviewPolicyData: [
    {
      policyType: "auto",
      policyDetails: {
        policyNumber: "PA82345678",
        policyTypeNumber: "Personal Auto Policy",
      },

      policyStatus: "Active",
      policyPremium: "$821",
      policyTerm: "01 Year",
      expiryDate: "3/21/2025",
      policyLastPayment: "18 Oct‘24 | $150",
    },
    {
      policyType: "House",
      policyDetails: {
        policyNumber: "HO82345679",
        policyTypeNumber: "Home Owners",
      },
      policyStatus: "Active",
      policyPremium: "$967",
      policyTerm: "01 Year",
      expiryDate: "08/03/2025",
      policyLastPayment: "No Pending Dues",
    },
    // {
    //   policyType: "Auto",
    //   policyDetails: {
    //     policyNumber: "PA82345278",
    //     policyTypeNumber: "Personal Auto Policy",
    //   },
    //   policyStatus: "Expired",
    //   policyPremium: "$936",
    //   policyTerm: "01 Year",
    //   policyIdNo: "Customer Name 2",
    //   policyLastPayment: "14 Jul‘24 | $150",
    // },
  ],
  overviewTableHeaders: [
    "",
    "Policy Details",
    "Status",
    "Premium",
    "Term",
    "Expiry Date",
    "Next Payment",
  ],
};
